export default {
  defaultInstructions: 'Select an image with a pose',
  cameraInstructions: 'Select an image or take a photo with a pose',
  poseNotFoundTryAgain: 'No pose was found. Try an image with good lighting, clean background, and only one person in frame.'
}
